import React, { useState } from 'react';
import { LandingHeader } from './Header';
import { LandingFooter } from './Footer';
import { BodyLanding } from './Body';
import styled from 'styled-components/macro';
import { useMainProviderContext } from 'context/main/provider';
import { useVideoSecurityAuthMutation } from 'queries/security/videoSecurityAuthMutation';
import { useParams } from 'react-router';
import { ProtectedVideo } from 'components/ProtectedVideo';
import { LoadingIndicator } from 'components/LoadingIndicator';
import { DocumentHead } from 'components/DocumentHead';
import { isCdkEnvironment } from 'utils/constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 100vh;
`;

export const LandingPage = () => {
  const { response } = useMainProviderContext();
  const { shortUrl } = useParams();

  const [passwordVerified, setPasswordVerified] = useState(false);

  const {
    mutateAsync: videoSecurityAuthMutation,
    isLoading: isLoadingVideoSecurity,
  } = useVideoSecurityAuthMutation({ setPasswordVerified });

  const unlockVideo = async (password?: string) => {
    if (!response?.videoId) {
      return;
    }
    await videoSecurityAuthMutation({
      shortUrl,
      password,
    });
  };

  if (response.video.protected && !passwordVerified) {
    return <ProtectedVideo loading={false} onSubmit={unlockVideo} />;
  }

  if (isLoadingVideoSecurity) {
    return (
      <LoadingIndicator isLoading={true} height={'100vh'} text={'Loading...'} />
    );
  }

  const title = isCdkEnvironment ? 'CDK Landing' : 'Covideo';
  return (
    <>
      <DocumentHead title={title} />
      <Container className='new-lp-flow'>
        <LandingHeader />
        <BodyLanding />
        <LandingFooter />
      </Container>
    </>
  );
};
